import * as loadjs from 'loadjs'
import EventManager from '../eventManager/EventManager'
import mediavineImage from '../../assets/small.png'
import type { Slot } from '../slots/Slot'
import SlotRepository from '../slots/SlotRepository'
const URL = 'https://adreporter.mediavine.com/assets/modal.js'

export class AdReporter {
  loaded = false
  constructor() {
    EventManager.on(EventManager.events.slotWrapperRenderEnded, (s) =>
      this.addReportButton(s)
    )
    document.addEventListener('click', (e) => this.handleReportButtonClick(e))
  }

  handleReportButtonClick(e: MouseEvent) {
    const clickTarget = e.target as Element
    if (!clickTarget.classList.contains('mv-ad-report-button')) {
      return
    }

    if (!this.loaded) {
      loadjs(URL, () => {
        this.loaded = true
        this.openAdReporter(clickTarget)
      })
    } else {
      this.openAdReporter(clickTarget)
    }
  }

  private openAdReporter(target: Element) {
    const targetId = target.getAttribute('data-target') || ''
    const adType = target.getAttribute('data-adtype') || 'video'
    const slot =
      adType === 'video'
        ? SlotRepository.getSlotById('video')
        : SlotRepository.getSlotById(targetId)

    window.$mediavine.adReporter.open(targetId, adType, slot)
  }

  addReportButton(slot: Slot) {
    if (
      slot.type === 'Adhesion' ||
      slot.type === 'UniversalPlayer' ||
      !slot.model.enable_mvp_branding
    ) {
      return
    }
    slot.wrapper.insertAdjacentHTML(
      'beforeend',
      `<div class='adunitlabel'>
        <button class='mv-ad-report-button' data-target='${slot.id}' data-adtype='display' aria-label='Report this ad'>
        </button>
        <div class='mediavine'>
          <a href='https://www.mediavine.com' target='_blank' rel="noopener" aria-label='mediavine'>
            <img 
              alt=''
              height='10' 
              width='82' 
              style='width:82px !important;height:10px !important;min-width:82px !important;min-height:10px !important;' 
              src=${mediavineImage}
            />
          </a>
        </div>
      </div>`
    )
  }
}
